
try {
  process.dlopen(module, __dirname + require("path").sep + __webpack_public_path__ + "71897a2ce078af32df09bb0c9a510d20.node");
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
